import ButtonGroupTabs from './ButtonGroupTabs';

export default ButtonGroupTabs;
